export default __webpack_public_path__ + "static/media/stamp3.e826f140.png";